import React from 'react';
import DocumentMeta from './DocumentMeta';
import { ROUTE_META } from './routeMeta';

const PrivacyAetherDash = () => (
  <div className="max-w-3xl mx-auto px-6 py-16 text-gray-800">
    <DocumentMeta
      title={ROUTE_META.aetherDash.title}
      description={ROUTE_META.aetherDash.description}
      robots={ROUTE_META.aetherDash.robots}
    />
    <h1 className="text-4xl font-bold mb-6">Privacy Policy for Aether Dash</h1>
    <p className="mb-4">
      <strong>Effective date:</strong> March 20, 2025
      <br />
      <strong>Last updated:</strong> March 20, 2025
      <br />
      <strong>App:</strong> Aether Dash (the "App")
      <br />
      <strong>Operator:</strong> Appazzola LLC, 231 E Canal St, Hershey, PA 17033 ("Appazzola", "we", "us", "our")
      <br />
      <strong>General contact:</strong> contact@appazzola.com
      <br />
      <strong>Privacy and legal contact:</strong> legal@appazzola.com
    </p>

    <p className="mb-4">
      Appazzola LLC ("we," "us," or "our") operates Aether Dash, a mobile and desktop game available on Google Play and itch.io. 
      This Privacy Policy explains how we collect, use, and protect your information when you play Aether Dash.
    </p>

    <h2 className="text-2xl font-semibold mt-6 mb-2">1. Information We Collect</h2>
    <ul className="list-disc list-inside mb-4">
      <li>User-Generated Data: Optional player name for leaderboard submission. If no name is given, a default like "Player1234" is used.</li>
      <li>Local Storage: Scores and progress are saved to your device (e.g., `dash_leaderboard.json`).</li>
      <li>No Personal Data: We do not collect sensitive personal information unless voluntarily entered into your player name.</li>
    </ul>

    <h2 className="text-2xl font-semibold mt-6 mb-2">2. How We Use Your Information</h2>
    <ul className="list-disc list-inside mb-4">
      <li>Leaderboard display via Dreamlo (http://dreamlo.com)</li>
      <li>Saving scores across sessions via local storage</li>
    </ul>

    <h2 className="text-2xl font-semibold mt-6 mb-2">3. Third-Party Services</h2>
    <p className="mb-4">
      We use <a href="http://dreamlo.com" className="text-teal-500 underline" target="_blank" rel="noopener noreferrer">Dreamlo</a> to manage global leaderboards.
      Data shared includes your player name and score. See their privacy policy for details.
    </p>

    <h2 className="text-2xl font-semibold mt-6 mb-2">4. Data Sharing</h2>
    <ul className="list-disc list-inside mb-4">
      <li>We do not share data except with Dreamlo for leaderboard functionality.</li>
      <li>We do not sell or use your data for advertising.</li>
    </ul>

    <h2 className="text-2xl font-semibold mt-6 mb-2">5. Data Security</h2>
    <p className="mb-4">
      Data is saved locally. We use standard HTTP for leaderboard updates but do not control Dreamlo’s server security.
    </p>

    <h2 className="text-2xl font-semibold mt-6 mb-2">6. Your Choices</h2>
    <ul className="list-disc list-inside mb-4">
      <li>Play offline to avoid leaderboard submission.</li>
      <li>Delete data by uninstalling or clearing app storage.</li>
    </ul>

    <h2 className="text-2xl font-semibold mt-6 mb-2">7. Children’s Privacy</h2>
    <p className="mb-4">
      Aether Dash is not intended for children under 13. We do not knowingly collect data from children.
      If you believe we have collected such data, please contact us.
    </p>

    <h2 className="text-2xl font-semibold mt-6 mb-2">8. Changes to This Policy</h2>
    <p className="mb-4">
      We may update this policy. Changes will be reflected on this page with an updated date.
    </p>

    <h2 className="text-2xl font-semibold mt-6 mb-2">9. Contact Us</h2>
    <p>
      For questions, contact Appazzola LLC<br />
      Email: <a href="mailto:contact@appazzola.com" className="text-teal-500 underline">contact@appazzola.com</a>
    </p>
  </div>
);

export default PrivacyAetherDash;
